/* Auto-generated by scripts/build-consulting-reports.js — do not edit */ const CONSULTING_REPORT_ARTICLES = [
    {
        "slug": "drone-report-202608",
        "type": "gatedPdf",
        "title": {
            "ja": "\u30C9\u30ED\u30FC\u30F3\u696D\u754C\u30EC\u30DD\u30FC\u30C8 2026\u5E748\u6708\u53F7\uFF1A\u30C9\u30ED\u30FC\u30F3\xd7\u8FB2\u696D",
            "en": "Drone Industry Report \u2014 August 2026: Drones in Agriculture"
        },
        "description": {
            "ja": "\u8FB2\u696D\u7528\u30C9\u30ED\u30FC\u30F3\u306E\u5E02\u5834\u52D5\u5411\u3001\u8FB2\u696D\u304C\u62B1\u3048\u308B3\u3064\u306E\u8AB2\u984C\u3068\u6D3B\u7528\u4E8B\u4F8B\u3001\u5C0E\u5165\u6642\u306E\u30CF\u30FC\u30C9\u30EB\u30921\u30DA\u30FC\u30B8\u306B\u307E\u3068\u3081\u307E\u3057\u305F\u3002\u5168\u6587\u306FPDF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
            "en": "A one-page brief on Japan\u2019s agricultural drone market, three farming challenges and drone applications, and barriers to adoption. Download the full PDF (Japanese)."
        },
        "tag": {
            "ja": "\u30C9\u30ED\u30FC\u30F3",
            "en": "Drone"
        },
        "publishedAt": "2026-08-31T00:00:00.000Z",
        "imageUrl": "assets/consulting-reports-images/drone-report-202608.svg",
        "pageCount": 1
    },
    {
        "slug": "drone-report-2026",
        "type": "gatedPdf",
        "title": {
            "ja": "\u30C9\u30ED\u30FC\u30F3\u696D\u754C\u30EC\u30DD\u30FC\u30C8 2026",
            "en": "Drone Industry Report 2026"
        },
        "description": {
            "ja": "\u7523\u696D\u7528\u30C9\u30ED\u30FC\u30F3\u306E\u5E02\u5834\u30FB\u898F\u5236\u30FB\u5B9F\u88C5\u3092\u77ED\u5831\u5F62\u5F0F\u3067\u307E\u3068\u3081\u305F\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0\u30EC\u30DD\u30FC\u30C8\u3067\u3059\u3002\u5168\u6587\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
            "en": "A short consulting brief on industrial drones\u2014market, regulation, and delivery. Download for the full PDF."
        },
        "tag": {
            "ja": "\u30C9\u30ED\u30FC\u30F3",
            "en": "Drone"
        },
        "publishedAt": "2026-07-22T00:00:00.000Z",
        "imageUrl": "assets/consulting-reports-images/drone-report-2026.png",
        "pageCount": 2
    }
];

//# sourceMappingURL=corporate-site.63554cb4.js.map
